import React from 'react'

import { ParagraphXs } from 'components/display/Typography'
import { refundNotice, refundAmount } from '../utils/cancellationUtils'
import { isAccommodation } from '../utils/listingUtils'

interface ListingProps {
  listing_type: {
    slug: string
  }
}
interface CancellationPolicyProps {
  listing: ListingProps
  policy: string
  short?: boolean
}

const CancellationPolicy = ({
  listing,
  policy,
  short,
}: CancellationPolicyProps) => {
  const firstSentence = () => (
    <>
      Receive a {refundAmount(policy)} refund{' '}
      {policy === 'partial' && 'of the total booking amount'} (minus service
      fee) up until {refundNotice(policy)} prior to{' '}
      {isAccommodation(listing) ? 'check-in' : 'the booking start date'}.
    </>
  )

  const secondSentence = () => (
    <>
      No refunds will be given for cancellations with less than{' '}
      {refundNotice(policy)} notice.
    </>
  )

  if (!policy) return null

  if (short) {
    return <ParagraphXs>{firstSentence()}</ParagraphXs>
  }

  return (
    <>
      <ParagraphXs noMargin>
        {firstSentence()} {secondSentence()}
      </ParagraphXs>
    </>
  )
}

export default CancellationPolicy
